import { CommonModule } from '@angular/common';
import { Component, computed } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Icon, ModalBasement, ModalContainer } from '@millionshow/client-libs';

interface InquiryCompleteModalProps {
  name: string;
  contact: string;
}

@Component({
  selector: 'app-inquiry-complete-modal',
  templateUrl: './inquiry-complete.modal.html',
  imports: [CommonModule, ModalContainer, Icon, RouterLink],
})
export class InquiryCompleteModal extends ModalBasement<InquiryCompleteModalProps> {
  name = computed(() => this.props()?.name || '');
  contact = computed(() => this.props()?.contact || '');
}
